import React, { useEffect, useState, useRef } from 'react';
import { useHistory } from "react-router";
import "bootstrap/dist/css/bootstrap.css";
import "./login.scss";
import UsersService from "services/http/users-service";
import logo_ooredoo from "assets/img/logo_ooredoo.png";
import Utils, { CUSTOM_MESSAGES } from "utils";
import { InputTextCustomer, CustomButton, ToastNotification, Alert } from 'components/shared';
import { Footer } from 'components/layout';


export const ResetPassword = (props) => {
    const history = useHistory();

    const [credentials, setCredentials] = useState({
        uuid: props.match.params.uuid, password: null, repeatedPassword: null
    });
    const [loading, setLoading] = useState(false);
    const childRef = useRef();
    const [error, setError] = useState();
    const [passwordError, setPasswordError] = useState();


    useEffect(() => {
        let uuid = { uuid: credentials.uuid };
        UsersService.validateForgotPassword(uuid).then(() => {
        }, error => {
            setError(error);
        });
    }, []);


    //submit reset password form
    const handleSubmit = (e) => {
        e.preventDefault();
        if (credentials.password != credentials.repeatedPassword) {
            childRef?.current?.showToast({
                type: "warn",
                title: "Error response",
                message: "Please enter the same password !", durable: false
            });
        }
        else {
            setLoading(true);
            UsersService.changeForgotPassword(credentials).then(result => {
                setLoading(false);
                childRef?.current?.showToast({
                    type: "success",
                    title: "Success response",
                    message: result.result, durable: false
                });
                setTimeout(() => history.push('/'), 2000);
            }, error => {
                setLoading(false);
                childRef?.current?.showToast({
                    type: "warn",
                    title: "Error response",
                    message: error, durable: false
                });
            });
        }
    }

    function handleResetPSWD(e) {
        setPasswordError("");
        setCredentials({ ...credentials, password: e.target.value });
        if (e.target.value.length < 8) {
            setPasswordError("The password provided must have a minimum of 8 characters");
        }
        else if (e.target.value.match(/([A-Z]+)/g) === null) {
            setPasswordError("The password provided must have at least 1 capital letter");
        }
        else if (e.target.value.match(/([*^$@_#&./:?!=+%]+)/g) === null) {
            setPasswordError("The password provided must have at least 1 special character");
        }
        else {
            setPasswordError("");
        }
    }

    return (
        <div className="container">
            {
                !error ?
                    <div style={{ padding: "70px 250px 6px" }}>
                        <div className="justify-content-center">
                            <div className="justify-content-center">
                                <div className="brand text-center">
                                    <br />
                                    <img src={logo_ooredoo} alt="Ooredoo" width={"60%"} /><br /><br />
                                </div>
                                <br />
                                <div className="card">
                                    <div className="card-body">
                                        <h4 className="card-title text-center">Please, change your password</h4>
                                        <form onSubmit={handleSubmit} className="my-login-validation">
                                            <InputTextCustomer id="newPassword"
                                                name='newPassword'
                                                required
                                                onChange={handleResetPSWD}
                                                type="password"
                                                label='New Password'
                                                icon="pi pi-lock"
                                            />
                                            <p style={{ color: '#ED1C24' }}>{passwordError}</p>

                                            <InputTextCustomer id="confirmedPassword"
                                                name='confirmedPassword'
                                                required
                                                onChange={e => { setCredentials({ ...credentials, repeatedPassword: e.target.value }) }}
                                                type="password"
                                                label='Confirm Password'
                                                icon="pi pi-lock"
                                            />
                                            <br />
                                            <CustomButton
                                                type="submit"
                                                label={Utils.labelTemplate(
                                                    <>
                                                        <i className="bi bi-check-circle" /> Submit
                                                    </>,
                                                    loading,
                                                    "Loading..."
                                                )}
                                                className="btn btn-primary btn-block"
                                            />

                                            <div className="mt-4 text-center form-bottom">
                                            </div>
                                        </form>
                                        <ToastNotification ref={childRef} />
                                    </div>
                                </div>
                                <Footer />
                            </div>
                        </div>
                    </div> : <div className="my-5 col-6 text-center" style={{ margin: "auto" }}>
                        <Alert icon="bi bi-exclamation-triangle" type="danger" content={<><span className="font-weight-bold">{error}</span><br />{CUSTOM_MESSAGES.SMTHG_WRONG_MESSAGE}</>} />
                    </div>
            }
        </div>

    );

}